import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DEPLOY_URL } from '@ppl/utils/injection-tokens';

@Component({
    selector: 'ppl-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundComponent {
  errorImageUrl = `${this.deployUrl}/assets/img/error-screen.png`;

  constructor(
    @Inject(DEPLOY_URL) private deployUrl: string
  ) { }
}
